import { useState, useCallback } from "react";

export const useApiCall = <T, P extends any[] = any[]>() => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<T | null | []>(null);

    const execute = useCallback(async (apiServiceCallback: (...args: P) => Promise<any>, ...args: P): Promise<T | null> => {
        setIsLoading(true);
        setError(null);
        setData(null);

        try {
            const response = await apiServiceCallback(...args);

            setData(response.data);
            return response as T;
        } catch (err: any) {
            const message = err?.response?.data?.message || err.message || "Ошибка запроса";
            setError(message);
            return null
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { execute, isLoading, error, data };
};